import { useTranslation } from "react-i18next";
import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Layout, Radio, RadioChangeEvent, Typography } from "antd";
import { TabsPosition } from "antd/es/tabs";
import { MenuProps } from "antd/lib";
import parse from "html-react-parser";
import { isEmpty } from "lodash";
import { FunctionComponent, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CourseContentPage from "../../components/course-content";
import "./course-preview.scss";
var indexDB = require("idbcache").default;

const ContentPreview: FunctionComponent = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation()
  const [mode, setMode] = useState<string>('admin');
  const [typeTemplates, setTypeTemplates] =
    useState<String>("Trang giới thiệu");

  const [html, setHTML] = useState<string>("");
  indexDB.get("courseSavedTemplete-" + params?.id).then((val: any) => {
    if (val) {
      let html = "";
      const parsecourseSavedTempalte = JSON.parse(val);
      if (parsecourseSavedTempalte.id === params?.id) {
        html = parsecourseSavedTempalte.html;
        html = html.replace(new RegExp("<body.*?>"), "").replace("</body>", "");
        const style = document.createElement("style");
        style.append(parsecourseSavedTempalte.css);
        const head = document.querySelector("head");
        head?.appendChild(style);
        setHTML(html);
      }
    }
  });

  const items: MenuProps["items"] = [
    {
      key: "0",
      label: (
        <Typography.Text
          className="span-full"
          onClick={() => {
            setTypeTemplates("Trang giới thiệu");
          }}
        >
          {t("Trang giới thiệu", "Trang giới thiệu")}
        </Typography.Text>
      ),
    },
    {
      key: "1",
      label: (
        <Typography.Text
          className="span-full"
          onClick={() => {
            setTypeTemplates("Trình phát khóa học");
          }}
        >
          {t("Trình phát khóa học", "Trình phát khóa học")}
        </Typography.Text>
      ),
    },
  ];

  const handleMenuClick: MenuProps["onClick"] = (e) => { };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  useEffect(() => {
    if (!isEmpty(location.search)) {
      setTypeTemplates("Trình phát khóa học")
    } else {
      setTypeTemplates("Trang giới thiệu");
    }
  }, [navigate]);

  const handleModeChange = (e: RadioChangeEvent) => {
    setMode(e.target.value);
  };

  return (
    <>
      <Layout>
        <div className="course-preview-action">
          <div className="course-preview-action__dropdowns">
            <Dropdown
              overlayClassName="course-preview-action__dropdowns__item"
              trigger={["click"]}
              menu={menuProps}
            >
              <Button className="btn">
                <Typography.Text>{typeTemplates}</Typography.Text>
                <DownOutlined />
              </Button>
            </Dropdown>

            {typeTemplates !== "Trang giới thiệu" && <div className="flex align-center gap-24">
              <div>{t("Xem bởi", "Xem bởi")}</div>
              <Radio.Group onChange={handleModeChange} value={mode} style={{ marginBottom: 8 }}>
                <Radio.Button value="admin">{t("Giảng viên", "Giảng viên")}</Radio.Button>
                <Radio.Button value="student">{t("Sinh viên", "Sinh viên")}</Radio.Button>
              </Radio.Group>
            </div>}
          </div>
        </div>

        <div className="course-preview-page-builder">
          {typeTemplates === "Trang giới thiệu" ? (
            html === "" || html === null ? (
              <h1 style={{ textAlign: "center" }}>{t("Chưa có mẫu", "Chưa có mẫu")}</h1>
            ) : (
              parse(html)
            )
          ) : (
            <div className="course-preview">
              <CourseContentPage isHideApprovedInformationTab={true} preview={true} mode={mode} />
            </div>
          )}
        </div>
      </Layout >
    </>
  );
};

export default ContentPreview;
